import { render, staticRenderFns } from "./SearchRecipientGroups.vue?vue&type=template&id=30c65a8c&scoped=true"
import script from "./SearchRecipientGroups.vue?vue&type=script&lang=js"
export * from "./SearchRecipientGroups.vue?vue&type=script&lang=js"
import style0 from "./SearchRecipientGroups.vue?vue&type=style&index=0&id=30c65a8c&prod&lang=scss"
import style1 from "./SearchRecipientGroups.vue?vue&type=style&index=1&id=30c65a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c65a8c",
  null
  
)

export default component.exports